module.exports = __webpack_public_path__ + "img/pic8.d05f6022.png";